import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function YourInfoIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 40 40" fill="none" {...props}>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M40 22.7907C38.8372 32.3256 31.6393 40 20.4651 40C10.4651 40 0 33.9648 0 22.7907C0 2.09302 11.384 0 22.5581 0C33.7323 0 40 11.6166 40 22.7907Z"
          fill="#ECF4FC"
        />
        <path
          d="M30.2032 22.0139C29.6336 26.684 26.1081 30.4429 20.6351 30.4429C15.7371 30.4429 10.6113 27.4869 10.6113 22.0139C10.6113 11.8762 16.1872 10.8511 21.6602 10.8511C27.1333 10.8511 30.2032 16.5408 30.2032 22.0139Z"
          fill="#3167F5"
        />
        <path
          d="M20.4951 16.21C19.0985 16.21 18.957 16.3691 18.957 14.9805C18.957 14.2927 19.1318 14.0801 20.4951 14.0801C21.1384 14.1516 21.6562 13.907 21.6563 15.1094C21.6563 16.3691 21.249 16.21 20.4951 16.21ZM21.0215 26.3857C20.4383 26.4411 19.0883 26.6241 19.0879 25.9541C19.0879 24.9112 19.0472 22.5882 19.0879 22.0898C19.1286 21.5916 19.0361 19.4583 19.1582 18.4951C19.1313 18.3622 19.2081 18.1033 19.7285 18.1299C20.2492 18.1564 20.7007 18.0756 21.1504 18.1299C21.5996 18.1843 21.544 18.6447 21.5439 18.6904C21.5446 19.0573 21.4805 20.3436 21.4805 20.6758C21.4806 21.0114 21.6724 25.2901 21.3877 25.9541C21.347 26.0939 21.3187 26.3856 21.0215 26.3857Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
}
